










 

 










const node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "OrgBillingDangerZone_organization",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ArchiveOrganization_organization"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isBillingLeader",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "billingTier",
      "storageKey": null
    }
  ],
  "type": "Organization",
  "abstractKey": null
};

(node ).hash = "006bedd68375fdf2350e27fc75d6baf8";

export default node;
